import { render, staticRenderFns } from "./WebAppsList.vue?vue&type=template&id=6a0b58d0&scoped=true"
import script from "./WebAppsList.vue?vue&type=script&lang=js"
export * from "./WebAppsList.vue?vue&type=script&lang=js"
import style0 from "./WebAppsList.vue?vue&type=style&index=0&id=6a0b58d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b58d0",
  null
  
)

export default component.exports